import { useCallback, useRef } from 'react';

import { useStoreService } from './use-store-service';

export type EngagementEventType =
  | 'buyup_engaged'
  | 'exception_logs_engaged'
  | 'sales_journal_engaged';

/**
 * Returns a one-shot trigger that records a qualified engagement event for
 * the onboarding timeline. The trigger fires at most once per component
 * mount; navigation away + back creates a fresh mount and a fresh ref. See
 * docs/superpowers/specs/2026-05-03-onboarding-timeline-design.md for the
 * "first qualified action per mount" rationale.
 */
export function useEngagement(eventType: EngagementEventType, storeId: string) {
  const fired = useRef(false);
  const storeService = useStoreService();

  return useCallback(
    (payload?: Record<string, unknown>) => {
      if (fired.current) {
        return;
      }

      fired.current = true;
      void storeService.recordEngagement(storeId, eventType, payload);
    },
    [eventType, storeId, storeService]
  );
}
